export default __webpack_public_path__ + "static/media/undo_icon.68429644.svg";